import { useMemo } from 'react'

export type VolcanoDataPoint = {
  log2FoldChange: number
  pValue: number
}

export type HeatmapDataPoint = {
  x: number
  y: number
  z: number
}

export type DotPlotDataPoint = {
  category: string
  value: number
  size: number
}

export const useMockChartData = () => {

  const generateVolcanoData = (numPoints: number): VolcanoDataPoint[] => {
    // from augustine - geenrating volcano data
    const data: VolcanoDataPoint[] = []

    for (let i = 0; i < numPoints; i++) {
     
      let log2FoldChange: number
      let pValue: number

      if (Math.random() < 0.7) {
        log2FoldChange = (Math.random() - 0.5) * 2
        pValue = Math.random() * 0.8 + 0.2
      } else {
        const direction = Math.random() > 0.5 ? 1 : -1
        log2FoldChange = direction * (Math.random() * 2 + 1.5)
        pValue = Math.pow(10, -(Math.random() * 2 + 1))
      }

      data.push({
        log2FoldChange: parseFloat(log2FoldChange.toFixed(2)),
        pValue: parseFloat(pValue.toFixed(6)),
      })
    }

    return data
  }

  const generateHeatmapData = (rows: number, cols: number) => {
    const data: HeatmapDataPoint[] = []
    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < cols; j++) {
        data.push({ x: i, y: j, z: Math.random() * 100 })
      }
    } 
    return data
  }

  const generateDotPlotData = () => {
    const data: DotPlotDataPoint[] = []

    return data
  }

  const volcanoData = useMemo(() => generateVolcanoData(1000), [])
  const heatmapData = useMemo(() => generateHeatmapData(3, 3), [])
  const dotPlotData = useMemo(() => generateDotPlotData(), [])

  return {
    volcanoData,
    heatmapData,
    dotPlotData,
  }
}
